<template>
  <div class="message-detail-page">
    <h1>学生打卡信息</h1>
    <div v-if="loading" class="loading">正在加载...</div>
    <div v-else-if="!record" class="empty">暂无打卡信息</div>
    <div v-else class="record-card">
      <div class="row"><span class="label">学生姓名：</span><span>{{ record.studentName }}</span></div>
      <div class="row"><span class="label">班级名称：</span><span>{{ record.className }}</span></div>
      <div class="row"><span class="label">家长姓名：</span><span>{{ record.parentName }}</span></div>
      <div class="row"><span class="label">家长手机号：</span><span>{{ record.parentPhone }}</span></div>
      <div class="row"><span class="label">打卡时间：</span><span>{{ record.pickUpTime }}</span></div>
      <div class="row"><span class="label">创建时间：</span><span>{{ record.createTime }}</span></div>
      <div class="row"><span class="label">更新时间：</span><span>{{ record.updateTime }}</span></div>
      <div class="row"><span class="label">学校编号：</span><span>{{ record.schoolNo }}</span></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getPickUpChildRecord } from '../api'

const route = useRoute()
const record = ref(null)
const loading = ref(false)

async function fetchRecord() {
  const pickUpRecordId = route.query.id || route.params.id
  if (!pickUpRecordId) return
  loading.value = true
  try {
    const res = await getPickUpChildRecord({ pickUpRecordId })
    if (res && res.data && res.data.data) {
      record.value = res.data.data
    } else {
      record.value = null
    }
  } catch (e) {
    record.value = null
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchRecord()
})
</script>

<style scoped>
.message-detail-page {
  max-width: 420px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.message-detail-page h1 {
  font-size: 22px;
  margin-bottom: 24px;
  color: #333;
  text-align: center;
}
.loading, .empty {
  text-align: center;
  color: #888;
  padding: 40px 0;
}
.record-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.row {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.label {
  color: #666;
  min-width: 100px;
}
</style>